<template>
	<countdown :end-time="dataFinal" @finish="endCallBack()">
		<template slot="process" slot-scope="data">
			<span>
				<small>Tempo de Sessão</small>
			</span>
			<br>
			<strong>
				<span>{{data.timeObj.h}}</span>
				<i>:</i>
				<span>{{data.timeObj.m}}</span>
				<i>:</i>
				<span>{{data.timeObj.s}}</span>
			</strong>
		</template>
		<template slot="finish">
			<span>
				<small>Sessão Finalizada</small>
			</span>
		</template>
	</countdown>
</template>

<script >
export default {
	name: 'TempoSessao',

	data() {
		return {
			dataFinal: null
		}
	},

	methods: {
		endCallBack() {
			this.$store.dispatch('logout')
		}
	},

	created() {
		// this.dataFinal = new Date().getTime() + 10000
		this.dataFinal = this.$store.getters.getExpirationDate
			? this.$moment(this.$store.getters.getExpirationDate).format(
					'YYYY/MM/DD HH:mm:ss'
			  )
			: ''
	}
}
</script>
